export default __webpack_public_path__ + "static/media/221111_provider.984944c9.pdf";